import React, { useRef } from "react";
import layoutPublicRoutesStyle from "./layoutPublicRoutesStyle";
import Footer from "@/src/components/Footer/Footer";
import ReleaseInfo from "@/src/components/ReleaseInfo/ReleaseInfo";
import ScrollTopButton from "@/src/components/Button/ScrollTopButton";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import { Box } from "@mui/material";
import SkipLink from "@/src/components/SkipLink/SkipLink";
import { useFlexServiceLayoutForCustomer } from "@/src/services/advocardService";
import NavigationBar from "@/src/components/Navigation/NavigationBar/NavigationBar";

type LayoutPublicRoutesProps = {
  minimal?: boolean;
  clickableLogo?: boolean;
  children?: React.ReactNode;
  withScrollToTopButton?: boolean;
};

export default function LayoutPublicRoutes({ minimal = false, clickableLogo = true, children, withScrollToTopButton = true }: LayoutPublicRoutesProps) {
  const skipLinkRef = useRef<HTMLAnchorElement>(null);
  const { customer } = useCustomer();

  const hideProductLinks = useFlexServiceLayoutForCustomer(customer);

  return (
    <>
      <ReleaseInfo />
      <Box sx={layoutPublicRoutesStyle.pageContainer}>
        <Box sx={layoutPublicRoutesStyle.content}>
          <SkipLink ref={skipLinkRef} />
          <NavigationBar minimal={minimal} clickableLogo={clickableLogo} />
          <Box component={"main"} sx={layoutPublicRoutesStyle.childrenContainer} id={"main-content"}>
            {children}
          </Box>
          {withScrollToTopButton && <ScrollTopButton skipLinkRef={skipLinkRef} />}
          <Footer hideProductLinks={hideProductLinks} />
        </Box>
      </Box>
    </>
  );
}
